import { Link } from 'react-router-dom';
import { FileText, Scan, Users, BarChart3, ArrowRight, Sparkles } from 'lucide-react';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Sparkles className="w-6 h-6 text-blue-600" />
            <span className="font-semibold text-slate-900">Eureka Business Cards</span>
          </div>
          <Link
            to="/scanned"
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
          >
            Sign In
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Business Card CRM
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Scan, organize, and manage your business cards with AI-powered OCR
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Digital Business Card */}
          <Link
            to="/config"
            className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all border border-slate-200"
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-blue-100 rounded-xl group-hover:bg-blue-200 transition-colors">
                <FileText className="w-6 h-6 text-blue-600" />
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-semibold text-slate-900 mb-2">
                  Create Your Digital Card
                </h2>
                <p className="text-slate-600 mb-4">
                  Design and share your professional digital business card with QR code
                </p>
                <div className="flex items-center text-blue-600 font-medium">
                  Get Started
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>

          {/* Scan Business Cards */}
          <Link
            to="/scanned"
            className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all border border-slate-200"
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-green-100 rounded-xl group-hover:bg-green-200 transition-colors">
                <Scan className="w-6 h-6 text-green-600" />
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-semibold text-slate-900 mb-2">
                  Scan Business Cards
                </h2>
                <p className="text-slate-600 mb-4">
                  Upload card images for AI-powered OCR extraction and CRM integration
                </p>
                <div className="flex items-center text-green-600 font-medium">
                  Open Scanner
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Features List */}
        <div className="mt-16 grid sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="inline-flex p-3 bg-purple-100 rounded-xl mb-4">
              <Users className="w-6 h-6 text-purple-600" />
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">CRM Integration</h3>
            <p className="text-sm text-slate-600">
              Sync contacts to your CRM automatically
            </p>
          </div>
          <div className="text-center">
            <div className="inline-flex p-3 bg-amber-100 rounded-xl mb-4">
              <BarChart3 className="w-6 h-6 text-amber-600" />
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">Sales Analytics</h3>
            <p className="text-sm text-slate-600">
              Track team performance and KPIs
            </p>
          </div>
          <div className="text-center">
            <div className="inline-flex p-3 bg-rose-100 rounded-xl mb-4">
              <Sparkles className="w-6 h-6 text-rose-600" />
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">AI Powered</h3>
            <p className="text-sm text-slate-600">
              Gemini Vision API for accurate extraction
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-slate-500">
          <p>Part of Eureka Labo Platform</p>
        </div>
      </footer>
    </div>
  );
}
